export class ViewValue {
  value: number | string | boolean
  viewValue: string

  constructor(val, view) { this.value = val, this.viewValue = view }

}
